import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import MpdxImportModel from 'donor-elf-web/models/mpdx-import';
import FundsService from 'donor-elf-web/services/funds-service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export interface MpdxImportRouteModel {
  mpdxImport?: MpdxImportModel;
  alreadyImporting: boolean;
}

export default class MpdxImportRoute extends Route {
  @service declare fundsService: FundsService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'MPDx Import';
  }

  async model(): Promise<MpdxImportRouteModel> {
    let mpdxImport = this.store.createRecord('mpdx-import', {
      includeGifts: false,
      includeTasks: true,
      includePledges: true,
    });
    let fundUpload = await this.store.findRecord(
      'fund-upload',
      this.fundsService.selectedFund!.id,
      { reload: true },
    );

    return {
      mpdxImport,
      alreadyImporting:
        fundUpload.progress != undefined && fundUpload.progress < 100,
    };
  }
}
